import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import darkTheme from '../../src/theme';
import parse from "html-react-parser";

const aboutEvent = {
    borderTop: `1px dotted`,
    borderColor: `#2F2F2F`,
    paddingTop: darkTheme.spacing(2),
    marginTop: darkTheme.spacing(2),
    marginBottom: darkTheme.spacing(1),
    '& h5': {
        fontSize: 14,
        textTransform: 'capitalize',    
        color: darkTheme.palette.primary.dates,       
        fontWeight: 400,    
    },
    '& h6': {
        fontSize: 16,
        color: darkTheme.palette.primary.location,
        fontWeight: 400,    
    }, 
};

const content = {
    fontSize: 16,
    color: darkTheme.palette.primary.location, 
    '& a': {
        fontSize: 14,
        color: darkTheme.palette.primary.location,
        textDecoration:'underline'
    },
    '& span': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& h5': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& h6': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& p': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& ul': {
        fontSize: 14,
        fontWeight: 100,
    },
};

function About({ data }) {    
    
    const SHOW_MORE_TEXT_LENGTH = 200;    
  
    const [minLength, setMinLength] = useState(SHOW_MORE_TEXT_LENGTH);    
    
    const toggleShowMin = () => {
        setMinLength(SHOW_MORE_TEXT_LENGTH)        
    }
    const toggleShowMax = () =>{
        setMinLength(data.description.length)         
    }

    const ShowMore = () => {
        return <Typography component="p" sx={{cursor:'pointer', color: darkTheme.palette.primary.main, display:'inline', ml:1}} onClick={toggleShowMax}>Show more...!</Typography>
    }

    const ShowLess = () => {
        return <Typography component="p" sx={{cursor:'pointer', color: darkTheme.palette.primary.main, display:'inline', ml:1}} onClick={toggleShowMin}>Show less...!</Typography>
    }
    
  return (
      <>   
        {data.description.length > 0 ? (      
            <Typography component="div" sx={aboutEvent}>                            
                <Typography variant="h5">About Deal</Typography>                      
                    <Typography component="div" sx={content}>
                        {parse((data.description).substring(0, minLength))}
                        {(data.description).length > minLength ? <ShowMore /> : <ShowLess />}  
                    </Typography>                                 
            </Typography> 
        ):('')}      
    </>
  );
}

export default About;
